var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBoatingRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.869 3.239a.62.62 0 0 0-1.108.38v11.154c0 .341.279.62.62.62h8.676a.623.623 0 0 0 .492-1.003L12.873 3.235l-.004.004zM10.08 6.744a.623.623 0 0 0-.693.248l-4.958 7.437a.618.618 0 0 0 .515.96h4.958c.34 0 .62-.279.62-.62V7.337a.615.615 0 0 0-.442-.593zM4.17 18.492h17.662l-.016.062a3.095 3.095 0 0 1-3.021 2.417H7.206a3.095 3.095 0 0 1-3.021-2.417l-.015-.062zm-1.55-1.86a.617.617 0 0 0-.604.756l.352 1.572a4.957 4.957 0 0 0 4.838 3.87h11.589a4.96 4.96 0 0 0 4.838-3.87l.352-1.572a.621.621 0 0 0-.604-.756H2.621z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBoatingRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-boating-regular.17290e21.svg";
export { ForwardRef as ReactComponent };